<div class="no-access-container">
  <div class="no-access-card">
    <h1 class="no-access-title">Access Denied</h1>
    <p class="no-access-message">
      You do not have permission to view this page.<br>
     
    </p>
   
  </div>
</div>
